<template>
  <Modal class="mask long-modal top-modal"  width="850" :loading="loading"
         style="max-height:80%; over-flow:auto"  v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">
      账单明细
      <div class="fr mr60 error-color">
        <span>{{`房间/床位数：${roomsCount}`}}</span>
        <span>{{`账单总额：${totalMoney}`}}</span>
      </div>
    </div>

    <div class=" pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="tableData" :loading="false"></table-list>
    </div>
    <div slot="footer">
      <div v-if="isRead">
        <Button  type="primary" size="large" @click="close">返回</Button>
      </div>
      <div v-else>
        <Button type="text" size="large" @click="close">返回</Button>
        <Button type="primary" size="large" @click="createContract">
          <span>确认并创建</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script type="text/ecmascript-6">
 import TableList from "components/TableList/index";
 import {epsContractcreate} from "../../../../api/contractList";
 import {formatDateTime} from "../../../../utils/format";

 export default {
  props:{
    projectFid:{
      type:String,
      default:''
    },
    parentContractFid:{
      type:String,
      default:''
    },
    n:{
      type:Number,
      default:0
    },
    tableData:{
      type:Array,
      default: []
    },
    isRead: {
      type: Boolean,
      default:true
    },
    roomsCount: {
      type:Number,
      default:0
    },
    totalMoney: {
      type:Number,
      default:0
    },
    rentData:{
      type:Object,
      default:null
    },
    data:{
      type:Object,
      default:null
    },
    conStartDate:{
      type:Date,
      default:''
    },
    roomIds: {
      type: String,
      default: ''
    },
    otherParams:{
      type:Object,
      default:null
    },
    cardIds:{
      type:Array,
      default:null
    }
  },
  watch:{
    n() {
      this.show = true
    }
  },
  components:{
    TableList
  },
 data () {
  return {
    show:false,
    canClick:true,
    loading:true,
    columns:[
      {
      title: "房间号",
      key: "houseNumber",
      align: "center"

      },
      {
        title: "标准月租金",
        key: "originRentPrice",
        align: "center"

      },
      {
        title: "实际月租金",
        key: "rentPrice",
        align: "center"
      },
      {
        title: "标准服务费",
        key: "originServicePrice",
        align: "center"
      },
      {
        title: "实际服务费",
        key: "servicePrice",
        align: "center"
      },
      {
        title: "标准押金",
        key: "originDepositPrice",
        align: "center"
      },
      {
        title: "实际押金",
        key: "depositPrice",
        align: "center"
      },

    ],

 };
 },
 methods:{
   format(data){
     if(!data){
       return ''
     }
     return formatDateTime(data,false)

   },
   changeLoading() {
     this.loading = false;
     this.$nextTick(() => {
       this.loading = true
     })
   },
   close() {
     this.show = false
   },
   createContract() {
     // 创建企业合同
     let businessQualificationPic=[]
     this.data.businessLicenseList.forEach(ele=>{
       businessQualificationPic.push({
         fid:ele.fid,
         url:ele.attachmentImgUrl
       })
     })
     let proxyPic=[]
     this.data.grantAuthList.forEach(ele=>{
       proxyPic.push({
         fid:ele.fid,
         url:ele.attachmentImgUrl
       })
     })

     let params={
       "conCycleCode": this.rentData.conCycleCode,
       "conEndDate": this.format(this.rentData.conEndDate),
       "conStartDate": this.format(this.conStartDate),
       "contractSignSubject": {
         "businessAddress": this.data.businessAddress,
         "businessQualification": this.data.businessQualification,
         "businessQualificationType": this.data.businessQualificationType,
         "businessQualificationPic": businessQualificationPic,
         "contactsIdcard": this.data.contactsIdcard,
         "contactsMail": this.data.contactsMail,
         "contactsName": this.data.contactsName,
         "customerUid": this.data.customerUid,
         "proxyPic": proxyPic,
         "signName": this.data.signName,
         "subjectType": 3,
         "userPhone": this.data.userPhone,
         contactsIdcardType:this.data.contactsIdcardType
       },
       "contractType": 1,
       parentContractFid:this.parentContractFid,
       "projectFid": this.projectFid,
       "rentType": this.rentData.rentType,
       "stockFids": this.roomIds,
       cardIds:this.cardIds
     }

     if(!this.canClick) return //canClick是false的时候不能点
     this.canClick = false; // 点了之后立马设置成false
     epsContractcreate(params).then(res=>{
       this.$Message.success('续约成功')
       this.$emit('done')
       this.show=false
       setTimeout(()=>{
         this.canClick = true; //操作完了就延迟两秒设置成true，意思是两秒内都不能点，只有true才能点
       }, 2000);
     }).catch(error=>{
       this.canClick = true; //catch的时候直接设置成true,用户可以再点
       this.changeLoading()
     })
   }
 }
}
</script>




